<!--  -->
<template>
  <div class=''>
    <img src="../../assets/img/customer-banner.png" width="100%" alt="">
    <Modular  obj="Customer" name="modular1"></Modular>
    <div class="customer">
        <Modular  obj="Customer" name="modular2"></Modular>
        <Modular  obj="Customer" name="modular3" class="custModular3"></Modular>
    </div>
    <Modular  obj="Customer" name="modular4"></Modular>
  </div>
</template>

<script>
import Modular from '../../components/Modular'
export default {
  name:'customer',
  components: {Modular},
  props:{},
  data() {
     return {

     };
  },
  computed: {},
  watch: {},
  created() {
 
  },
  mounted() {

  },
  //方法集合
  methods: {

  },
}
</script>
<style lang='scss'>
  //@import url(); 引入公共css类
    .customer{
      .module img{
          width:80%;
      }
    }
    .custModular3{
      h3.h3{
        padding:0 25px;
        font-size:28px;
        line-height:50px;
        text-align: center;
        margin-bottom:45px;
        font-weight: normal;
      }
    }
</style>